export function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; //최댓값은 제외, 최솟값은 포함
}

export function getIconIdByServicePath(targetServiesInfos: TargetServiceInfos){
  const targetServiesInfo = findTargetServiceInfo(targetServiesInfos);
  if(!targetServiesInfo) return undefined;

  const targetIconId = findTargetIconIdByPath(targetServiesInfo);
  if(!targetIconId) return undefined;

  return Number(targetIconId);
}

function findTargetIconIdByPath(tagetServiceInfo: TargetServiceInfo){
  const pathName = location.pathname;
  const targetContentId = tagetServiceInfo.mappedPathToIconId[pathName];

  return targetContentId;
}

function findTargetServiceInfo (targetServiesInfos: TargetServiceInfos = []){
  const hostName = location.hostname;
  const tagetServiceInfo  = targetServiesInfos.find(targetServiesInfo => targetServiesInfo.domain.includes(hostName));

  return tagetServiceInfo;
}

